import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    question: "How do I know if I'm a candidate for Invisalign?",
    answer: 'Most adults are excellent candidates for Invisalign. During your free consultation, Dr. Lima will take a 3D scan of your teeth and let you know exactly what is possible for your specific smile.'
  }, {
    question: 'How much does Invisalign cost?',
    answer: 'The cost varies depending on the complexity of your case. However, with our current promotion, you receive $3,000 off your treatment plan. We also offer flexible monthly payment options to make it affordable.'
  }, {
    question: 'Is the consultation really free?',
    answer: 'Yes! Your initial consultation, including a 3D digital scan and a discussion with Dr. Lima about your goals, is completely free with no obligation to proceed.'
  }, {
    question: 'How long does Invisalign treatment take?',
    answer: "While every smile is unique, most adult treatments take between 12 to 18 months. You'll start seeing noticeable changes in just a few weeks!"
  }, {
    question: 'Is Invisalign noticeable?',
    answer: "Invisalign clear aligners are virtually invisible. Most people won't even realize you're wearing them, making it perfect for professionals and adults who want discreet treatment."
  }, {
    question: 'Can adults get Invisalign?',
    answer: "Absolutely! In fact, a large percentage of our Invisalign patients are adults who finally decided to invest in the smile they've always wanted."
  }, {
    question: 'Is the $3,000 off promotion limited?',
    answer: 'Yes, this is a special limited-time offer for residents of Miami Lakes, Hialeah, and Doral. We recommend claiming your offer now to lock in the savings.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-10 lg:py-20 bg-white" data-id="element-63">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-64">
        <div className="text-center mb-8 lg:mb-12" data-id="element-65">
          <h2 className="text-3xl md:text-4xl font-light text-brand-dark mb-3 lg:mb-4" data-id="element-66">
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-brand-dark/60" data-id="element-67">
            Everything you need to know about starting your Invisalign journey.
          </p>
        </div>

        <div className="space-y-2 lg:space-y-4" data-id="element-68">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.05
        }} className="border border-brand-dark/10 rounded-xl overflow-hidden" data-id="element-69">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-4 lg:p-6 text-left hover:bg-brand-dark/5 transition-colors" data-id="element-70">
                <span className="font-medium text-brand-dark pr-4 text-sm lg:text-base" data-id="element-71">
                  {faq.question}
                </span>
                <ChevronDown className={`w-5 h-5 text-brand-dark/40 transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-72" />
              </button>
              <AnimatePresence data-id="element-73">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-74">
                    <div className="p-4 lg:p-6 pt-0 text-brand-dark/60 text-sm lg:text-base" data-id="element-75">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}